import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/settings/company_store_settings/Page";
import useItandiAccount from "~/hooks/useItandiAccount";

export const PATH = "/settings/company_store_settings";

function Home() {
	const { data: session } = useItandiAccount().currentAccount();

	if (session === null) {
		return null;
	}

	return (
		<>
			<NskHead title="店舗項目設定" />
			<Component session={session} />
		</>
	);
}
export default Home;
